export function normalizeFaSearchText(value: string): string {
  return value
    .normalize('NFKC')
    .replace(/[كڪ]/g, 'ک')
    .replace(/[يىی]/g, 'ی') // ي عربی، ى، ی فارسی → یکسان
    .replace(/ةۀ/g, 'ه')
    .replace(/[أإٱآ]/g, 'ا')
    .replace(/[ؤ]/g, 'و')
    .replace(/[ئ]/g, 'ی')
    .replace(/[۰-۹]/g, (d) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(d)))
    .replace(/[\u0640]/g, '')
    .replace(/[\u064B-\u065F\u0670]/g, '')
    .replace(/[\u200c\u200d\u200f\u200e]/g, ' ')
    .replace(/[^\p{L}\p{N}\s]/gu, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}
